export default {
  async safeJson(response) {
    try {
      return await response.json();
    } catch {
      return null;
    }
  }
};
